import { render, staticRenderFns } from "./RoleOrganizations.vue?vue&type=template&id=dc8f1548&"
import script from "./RoleOrganizations.vue?vue&type=script&lang=ts&"
export * from "./RoleOrganizations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports